import { useSelector } from "react-redux";

const UsersHappi = () => {
  const OrgId = useSelector((state) => state.auth.org_id);
    return (
      <div className="">
          <iframe src={`https://iiplwork.retool.com/embedded/public/ea5747cc-130c-4048-ab65-ba32359d2ff2`}
          className="iframe-style"></iframe>
      </div>
  
    )
  };
  
  export default UsersHappi;
  